import { useSelector } from "react-redux";
import { isCommissionWallet } from "../Transfers/OtherWallet/InitiateTransfer";

function Header() {
  const user = useSelector((state) => state.user.user);
  return (
    <header className="bg-primary pt-9 pb-11 d-none d-md-block">
      <div className="container-md">
        <div className="row align-items-center">
          <div className="col">
            <h1 className="fw-bold text-white mb-2">Settings</h1>

            {user
              ? user.wallets
                  .filter(
                    (w) =>
                      !isCommissionWallet(w.product_id) && w.type !== "savings",
                  )
                  .map((w) => (
                    <p className="fs-lg text-white-75 mb-0" key={w.id}>
                      <span className="text-reset">{`${w.name}: ${w.account_no}`}</span>
                    </p>
                  ))
              : ""}
          </div>
          <div className="col-auto">
            <a href="/dashboard" className="btn btn-sm btn-gray-300-20">
              Back to Dashboard
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
